

<h2 class="h3">{{'metering.item.functioncontrol.contract'|translate}}</h2>
<div class="metering-point-item__functioncontrol-contract-text">{{functionControlContract?.energyServiceName}}</div>


